import { Symbols } from "@tenforce/toolbox-fontmap"

export const ButtonSymbols = new Map<string, string>(
    Object.entries({
        ArrowForward: Symbols.ArrowForward,
        BulkUpdate: Symbols.ArrowCheck,
        Cancel: Symbols.Cancel,
        ChangeView: Symbols.WorkspaceGridSettings,
        Chart: Symbols.GraphView,
        Configure: Symbols.Configure,
        Confirm: Symbols.Confirm,
        Copy: Symbols.Copy,
        Create: Symbols.Create,
        Crosshair: Symbols.Crosshair,
        CurrentTimesheet: Symbols.Move,
        Delete: Symbols.Delete,
        Export: Symbols.Export,
        FullScreen: Symbols.FullScreen,
        Import: Symbols.Import,
        Link: Symbols.Link,
        Mail: Symbols.Email,
        Password: Symbols.Password,
        Preview: Symbols.Preview,
        Print: Symbols.Print,
        Profile: Symbols.User,
        QuickEdit: Symbols.Font,
        Recall: Symbols.Recall,
        Recurring: Symbols.ArrowClockWise,
        Refresh: Symbols.ArrowClockWise,
        Report: Symbols.Reports,
        Reset: Symbols.ArrowCounterClockWise,
        ResetCheckmark: Symbols.ArrowCheck,
        Save: Symbols.Confirm,
        Script: Symbols.Script,
        Scroll: Symbols.Scroll,
        Send: Symbols.Send,
        Split: Symbols.Split,
        Time: Symbols.ShowTime,
        Timesheet: Symbols.Timesheet,
        Unlink: Symbols.Disconnect,
        UnlockUserAccount: Symbols.OpenLock,
    }),
)

export default ButtonSymbols
